<div class="admin-modal template-edit-modal">
  <!-- Header -->
  <div class="modal-header">
    <h3 class="modal-title">{{ title }}</h3>
    <div class="header-actions">
      <i class="fa"
        [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
        style="margin-right: 10px; cursor: pointer;"
      (click)="minimise = !minimise"></i>
      <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
    </div>
  </div>

  <!-- Step Indicator -->
  <div class="step-bar" [hidden]="minimise">
    <div class="step-item" [ngClass]="step1Class">
      <i class="fa fa-arrow-circle-right fa-3x"></i>
      <br />
      <small>1. {{ step1Title }}</small>
    </div>
    <div class="step-item" [ngClass]="step2Class">
      <i class="fa fa-arrow-circle-right" style="font-size: 40px;"></i>
      <br />
      <small>2. {{ step2Title }}</small>
    </div>
    <div class="step-item" [ngClass]="step3Class">
      <i class="fa fa-crosshairs" style="font-size: 40px;"></i>
      <br />
      <small>3. END</small>
    </div>
  </div>

  <!-- Body -->
  <div class="modal-body" [hidden]="minimise">
    <form #templateForm="ngForm" novalidate>

      @if (loading) {
        <div class="formLoader">
          <i class="fa fa-spinner fa-spin fa-2x"></i>
        </div>
      }

      <!-- Status Bar -->
      @if (!loading && !step3Flag) {
        <div class="status-bar">
          <span class="status-icon">&nbsp;</span>
          <span class="status-message">&nbsp;{{ userStatusMessage }}</span>
        </div>
      }
      @if (step3Flag && !loading) {
        <div class="status-bar">
          <span class="status-message status-message-success">{{ userStatusMessage }}</span>
        </div>
      }

      <!-- ============ STEP 1: Template Details ============ -->
      @if (slideStep1Div && !loading) {
        <div class="step-panel">
          <div class="detail-box">
            <div class="row">
              <div class="col-md-3 text-left">
                <label>Template Name</label>
                <input type="text" class="form-control input-sm" name="template_name"
                  placeholder="enter template name"
                  #templateNameCtrl="ngModel"
                  [(ngModel)]="template_data.template_name"
                  required />
                  @if (templateNameCtrl.invalid && (templateNameCtrl.touched || submitted)) {
                    <span class="form-error-container"
                      >
                      Template Name is required.
                    </span>
                  }
                </div>

                <div class="col-md-3 text-left">
                  <label>Template Description</label>
                  <textarea class="form-control input-sm"
                    name="template_description"
                    [(ngModel)]="template_data.template_description"
                    placeholder="enter template description"
                  maxlength="100"></textarea>
                </div>

                <div class="col-md-3 text-left">
                  <label>Template Group</label>
                  <select class="form-control input-sm" name="template_group"
                    [(ngModel)]="template_data.template_group"
                    [compareWith]="compareTemplateGroup"
                    required>
                    <option [ngValue]="undefined" disabled></option>
                    @for (key of templateGroupKeys; track key) {
                      <option [ngValue]="templateGroups[key]">{{ key }}</option>
                    }
                  </select>
                  @if (submitted && !template_data.template_group) {
                    <span class="form-error-container"
                      >
                      Template Group is required.
                    </span>
                  }
                </div>

                <div class="col-md-3 text-left">
                  <label>Template Status</label><br />
                  <span class="status-toggle"
                    [ngClass]="isActive ? 'status-toggle-active' : 'status-toggle-inactive'"
                    [class.disabled]="mode === 'new'"
                    (click)="mode !== 'new' && toggleStatus()">
                    {{ isActive ? 'Active' : 'Inactive' }}
                  </span>
                </div>
              </div>
              @if (mode === 'new' && templateTypes.length > 0) {
                <div class="row" style="margin-top: 10px;">
                  <div class="col-md-3 text-left">
                    <label>Template Type</label>
                    <select class="form-control input-sm" name="template_type"
                      [(ngModel)]="template_data.template_type_key"
                      (ngModelChange)="onTemplateTypeChange($event)"
                      [disabled]="templateTypes.length === 1"
                      required>
                      @if (templateTypes.length > 1) {
                        <option [ngValue]="undefined" disabled>Select template type</option>
                      }
                      @for (type of templateTypes; track type) {
                        <option [ngValue]="type.template_type_key">
                          {{ type.template_type_name }}
                        </option>
                      }
                    </select>
                    @if (submitted && !template_data.template_type_key) {
                      <span class="form-error-container"
                        >
                        Template Type is required.
                      </span>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        }

        <!-- ============ STEP 2: Module Assignment ============ -->
        @if (slideStep2Div && !loading) {
          <div class="step-panel step-panel--modules">
            <div class="detail-box">
              <span><strong>Template:</strong>&nbsp;{{ template_data.template_name }}&nbsp;
              <strong>For</strong>&nbsp;{{ selectedClientName }}</span>
              <span style="margin-left: 16px;">
                <strong>Total:</strong>&nbsp;<strong>{{ totalModulesAssigned }}</strong>&nbsp;Modules Selected
                out of&nbsp;<strong>{{ totalModulesForSelectedClient }}</strong>
              </span>
            </div>
            <div class="row panel panel-default module-assign-panel">
              <div class="panel-heading">
                Application Modules:
                <select class="form-control input-sm app-select"
                  name="selectedApplication"
                  [ngModel]="selectedApplication"
                  (ngModelChange)="selectApplication($event)">
                  @for (app of userAssignNav; track $index) {
                    <option [ngValue]="app">{{ app.name }}</option>
                  }
                </select>
                <div class="module-toolbar">
                  <button type="button" class="btn btn-sm button-lable" (click)="toggleAll()">
                    <span class="fa" [ngClass]="allExpanded ? 'fa-folder' : 'fa-folder-open'"></span>
                    {{ allExpanded ? 'Collapse All' : 'Expand All' }}
                  </button>
                  <input type="text"
                    placeholder="Search Item..."
                    class="module-search"
                    [ngModel]="searchTerm"
                    (ngModelChange)="filterMenu($event)"
                    [ngModelOptions]="{standalone: true}" />
                  </div>
                </div>
                <div class="panel-body module-panel-body">
                  @if (filteredUserAssignNav.length > 0) {
                    <div class="modules-columns">
                      @for (col of moduleColumns; track trackByIndex($index)) {
                        <div class="column">
                          @for (node of col; track trackByNodeId($index, node)) {
                            <div class="module-card">
                              <div class="activity-num" [ngClass]="node._badgeClass">
                                {{ node._assigned || 0 }}/{{ node._total || 0 }}
                              </div>
                              <div class="card-header">
                                <b class="ellip">{{ node.name }}</b>
                                <span style="float:right">
                                  <i class="fa fa-user-circle-o user" [title]="node._tooltip"></i>
                                  <i class="fa pls-icon" (click)="toggleNode(node)"
                                  [ngClass]="node.collapsed ? 'fa-plus-square-o' : 'fa-minus-square-o'"></i>
                                </span>
                              </div>
                              <div class="card-assign">
                                <b>Assign:</b>&nbsp;
                                <select class="assign-dropdown"
                                  [(ngModel)]="node._bulkDropdown"
                                  [ngModelOptions]="{standalone: true}"
                                  (ngModelChange)="applyGroupRole($event, node); node._bulkDropdown = ''">
                                  <option value="" disabled>select Level</option>
                                  <option value="0">No Access</option>
                                  <option value="-1">Lowest Level</option>
                                  <option value="1">Highest Level</option>
                                </select>
                              </div>
                              @if (!node.collapsed && node.children?.length) {
                                <div class="card-body">
                                  <div class="channel">{{ node.name }}</div>
                                  <div class="user-assign-btn-group">
                                    <button type="button" class="btn user-btn" (click)="openUserAccessModal(node)">
                                      <i class="fa fa-user-circle user-icn"></i>Assign User
                                    </button>
                                  </div>
                                  <ng-container *ngTemplateOutlet="treeLevel; context: { $implicit: node }"></ng-container>
                                </div>
                              }
                            </div>
                          }
                        </div>
                      }
                    </div>
                  } @else {
                    <div class="module-list-placeholder">No modules found.</div>
                  }
                </div>
              </div>
            </div>
          }

          <!-- ============ STEP 3: END ============ -->
          <!-- Verified against original: step3 only shows success message + Close button in footer. No additional functionality. -->

        </form>
      </div>

      <!-- Footer -->
      @if (!loading) {
        <div class="modal-footer" [hidden]="minimise">
          @if (!slideStep1Div && !step3Flag) {
            <button class="btn btn-info btn-sm" type="button"
            (click)="previousScreen()">Previous</button>
          }
          <button class="btn btn-info btn-sm" type="button" (click)="save()">
            @if (crudLoading) {
              <span><i class="fa fa-spinner fa-pulse"></i></span>
              } {{ saveLabel }}
            </button>
            <button class="btn btn-warning btn-sm" type="button" (click)="cancel()">Cancel</button>
          </div>
        }
      </div>

      <ng-template #treeLevel let-parentNode>
        <ul class="tree-structure">
          @for (ch of parentNode.children; track trackByNodeId($index, ch)) {
            <li
              [class.has-children]="ch.children?.length">
              <div class="tree-row">
                <span class="task">{{ ch.name }}</span>
                @if (ch.roles?.length > 0) {
                  <div class="pull-right">
                    <select class="child-select"
                      [ngModel]="ch.role?.value != null ? ch.role.value : ch.roles[0]?.value"
                      (ngModelChange)="onNodeRoleValueChange(ch, $event)"
                      [ngModelOptions]="{standalone: true}"
                      [class.has-access]="ch.role?.value > 0">
                      @for (role of ch.roles; track role) {
                        <option [value]="role.value">{{ role.label || role.name }}</option>
                      }
                    </select>
                  </div>
                }
              </div>
              @if (ch.children?.length) {
                <ng-container *ngTemplateOutlet="treeLevel; context: { $implicit: ch }"></ng-container>
              }
            </li>
          }
        </ul>
      </ng-template>
